export default "__VITE_ASSET__CjqLUtK1__ 584w";